import { createContext, useContext } from 'react';
import type { EmployeeQuestion, QuestionFieldKey } from './questionFields';

export interface QuestionsApi {
  /** Questions this employee already asked about one field (newest first), with any reply. */
  forField(key: QuestionFieldKey): EmployeeQuestion[];
  /** Opens the question box for a field. */
  ask(key: QuestionFieldKey): void;
}

/** Null outside the onboarding layout, so a read-only field there simply shows no Ask button. */
export const QuestionsContext = createContext<QuestionsApi | null>(null);

export const useQuestions = () => useContext(QuestionsContext);
